import { FormattedMessageTemplate } from "@idw-types/data/message-template";

export enum MessageTemplatesActionTypes {
    // Email Templates
    SET_MESSAGE_TEMPLATES_LOADING = "SET_MESSAGE_TEMPLATES_LOADING",
    SET_MESSAGE_TEMPLATES = "SET_MESSAGE_TEMPLATES",
    ADD_MESSAGE_TEMPLATE = "ADD_MESSAGE_TEMPLATE"
}

// Email Templates
type SetMessageTemplatesLoadingAction = {
    type: MessageTemplatesActionTypes.SET_MESSAGE_TEMPLATES_LOADING,
    payload: { isLoading: boolean; }
};

export const setMessageTemplatesLoading = (isLoading: boolean): SetMessageTemplatesLoadingAction => ({
    type: MessageTemplatesActionTypes.SET_MESSAGE_TEMPLATES_LOADING,
    payload: { isLoading }
});

type SetMessageTemplatesAction = {
    type: MessageTemplatesActionTypes.SET_MESSAGE_TEMPLATES,
    payload: { messageTemplates: Array<FormattedMessageTemplate>; }
}

export const setMessageTemplates = (messageTemplates: Array<FormattedMessageTemplate>): SetMessageTemplatesAction => ({
    type: MessageTemplatesActionTypes.SET_MESSAGE_TEMPLATES,
    payload: { messageTemplates }
});

type AddMessageTemplateAction = {
    type: MessageTemplatesActionTypes.ADD_MESSAGE_TEMPLATE;
    payload: { messageTemplate: FormattedMessageTemplate };
};

export const addMessageTemplate = (messageTemplate: FormattedMessageTemplate): AddMessageTemplateAction => ({
    type: MessageTemplatesActionTypes.ADD_MESSAGE_TEMPLATE,
    payload: { messageTemplate }
});

export type MessageTemplatesActions =
    // Email Templates
    SetMessageTemplatesLoadingAction |
    SetMessageTemplatesAction |
    AddMessageTemplateAction